import { Action, combineReducers } from 'redux';
import { persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { getType } from 'deox';

import { resetStore } from 'modules/app/actions';

import { userReducer } from 'modules/user/reducer';
import { companiesReducer } from 'modules/companies/reducer';
import { artworksReducer } from 'modules/artworks/reducer';
import { artworkReducer } from 'modules/artwork/reducer';

import { Store } from 'types';

const ErrorAndLoadingTransform = createTransform(
  (inboundState: Record<string, unknown>) => {
    const formattedInboundState: { [key: string]: unknown } = {};
    let key: string;
    // eslint-disable-next-line no-restricted-syntax
    for (key in inboundState) {
      if (key.toLowerCase().includes('error')) {
        formattedInboundState[key] = null;
      } else if (key.toLowerCase().includes('loading')) {
        formattedInboundState[key] = false;
      } else {
        formattedInboundState[key] = inboundState[key];
      }
    }
    return formattedInboundState;
  },
  (outboundState) => {
    return outboundState;
  },
  { whitelist: ['user'] },
);

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],
  transforms: [ErrorAndLoadingTransform],
};

const allReducers = combineReducers<Store>({
  user: userReducer,
  companies: companiesReducer,
  artworks: artworksReducer,
  artwork: artworkReducer,
});

const rootReducer = (state: Store | undefined, action: Action): ReturnType<typeof allReducers> => {
  if (action.type === getType(resetStore)) {
    state = undefined;
  }
  return allReducers(state, action);
};

export default persistReducer(persistConfig, rootReducer);
